<script lang="ts" setup>
import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import { i18n } from '@/i18n';
import { computed, ref, watch } from 'vue';

const props = defineProps<{
  modalState: boolean;
}>();

const emits = defineEmits<{
  (e: 'close'): void;
  (e: 'apply', inputText: string): void;
}>();

//変数
const t = i18n.t;

const inputText = ref('');

const isDisabledApplyButton = computed(() => {
  return inputText.value === '';
});

watch(
  () => props.modalState,
  (newVal) => {
    console.log('newVal', newVal);
    if (newVal) {
      inputText.value = '';
    }
  }
);
</script>

<template>
  <InfoModal
    :modal-state="modalState"
    :back-button-label="t('キャンセル')"
    :next-button-label="t('新規作成')"
    :modal-width="764"
    :is-disabled-next-button="isDisabledApplyButton"
    @on-back="emits('close')"
    @on-next="emits('apply', inputText)"
  >
    <template #title>{{ t('グループの新規作成') }}</template>
    <template #description>{{ t('取引をまとめる任意のグループを新規作成します。') }}</template>

    <div class="create-group-modal-content__main-content main-content">
      <div class="main-content__container">
        <div class="main-content__title">
          {{ t('グループを新規作成') }}
        </div>
        <input v-model="inputText" type="text" class="main-content__input" />
      </div>
    </div>
  </InfoModal>
</template>

<style lang="scss" scoped>
.create-group-modal-content {
  height: 100%;
  display: grid;
  grid-template-rows: auto 1fr auto;
  gap: 24px;
}

.main-content {
  background-color: $backgroundDefault;
  border-radius: 8px;

  &__container {
    height: 100%;
    width: 100%;
    padding: 16px;
    display: grid;
    grid-template-rows: repeat(2, auto);
    gap: 8px;
  }

  &__title {
    font-size: 14px;
    font-weight: 400;
    color: $textDefault;
  }

  &__input {
    width: 100%;
    box-sizing: border-box;
    background-color: $semanticWhite;
    border-radius: 4px;
    border: 1px solid $borderDefault;
    font-size: 14px;
    font-weight: 400;
    color: $textDefault;
    padding: 7px 8px;
  }
}
</style>
